export const GTAG_EVENT = {
  navToHome: "navegacion_a_inicio",
  navToEmployment: "navegacion_a_empleos",
  navToServices: "navegacion_a_servicios",
  navToAboutUs: "navegacion_a_nosotras",
  navToProcess: "navegacion_a_proceso",
  clickOnService: "click_servicio",
  clickOpenPosition: "click_posicion_abierta",
  clickOnClassroom: "click_curso",
};

export const gtagMixin = {
  methods: {
    clickOnClassroom(id) {
      this.sendEventGtag(GTAG_EVENT.clickOnClassroom, { id });
    },
    clickOpenPosition(id) {
      this.sendEventGtag(GTAG_EVENT.clickOpenPosition, { id });
    },
    clickOnService(id) {
      this.sendEventGtag(GTAG_EVENT.clickOnService, { id });
    },
    navToProcess() {
      this.sendEventGtag(GTAG_EVENT.navToProcess);
    },
    navToAboutUs() {
      this.sendEventGtag(GTAG_EVENT.navToAboutUs);
    },
    navToServices() {
      this.sendEventGtag(GTAG_EVENT.navToServices);
    },
    navToHome() {
      this.sendEventGtag(GTAG_EVENT.navToHome);
    },
    navToEmployment() {
      this.sendEventGtag(GTAG_EVENT.navToEmployment);
    },

    sendEventGtag(eventName, params) {
      console.log(eventName);
      this.$gtag.event(eventName, {
        event_name: eventName,
        ...params,
      });
    },
  },
};
